// VideoDisp.js
import React, { useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import YouTube from 'react-youtube';
import { db } from '../Firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import './VideoDisp.css';
import countdownSound1 from './assets/countdown1.mp3';
import countdownSound2 from './assets/countdown2.mp3';
import countdownSound3 from './assets/countdown3.mp3';
import correctSound from './assets/true.wav';
import wrongSound from './assets/wrong.wav';

const VIDEO_LIST = [
  "xYqskdJ-KuY","xw6dHNqADHw","z8HjnBYyllU","bN9gcqQ9Bl4","lrJtVn3BwuQ","2P8VBSysGIU","AYbvH83TglE","IdLvzUE_5YM","3YukRCZ-3_8","7A8NEfzFqXQ",
  "IBfv93XdaIY","d9B3tRcX82Q","mt9og4KeLBY","2BOo0LDe_4c","xjRVzECDaJI","fNibWzQak0c","aNNtKhR45wE","8T2vwWSP6K8","aT7T8ewlDuM","3NLZv2Nd-fs",
  "OqcR8QZ118Y","3l0fWPHc_zU","-CCZ4AXcLYE","oHrHAN9JO6w","lY6mD-gijMw","0IoOX3rkc88","7qUWfCd__LY","KNNqMkAhXfc","p1Akc1x7w5k","-yEpas1odd0",
  "wuQnEcqmqkw","K2EO9wDZTrc","u2O8nJAZOy0","loIaVcefDKQ","8epduqPdULA","2Nc2OZ3e8jA","sC1AcOqbwDc","HYEyxbibmzM","PTIRZyzeIqA","w0cw6a7krHs",
  "EJphWSGUBlQ","YVT160_xyFA","SyBBKKpaxaY","mxsAYpCThgU","v8lNulC4_qU","8pi4eTcWBPY","wLi389bj6s8","Qk91Cumgx4M","tUa7yGapYQ8","H-IQ49a9CDg",
  "uaiY_nJPHBo","CxRD4ymtcQc","U8Q1o8XjDro","ht2O2wUDGLg","07fZCWbbSVM","SLtXnpi33hg","MUsRfbxUeJ0","RDjWorIHjC8","puJCBYX5WiY","Ht1tKIWD_VI",
  "7NdifwJaqvI","luGDcFBvL7Q","abziH6P_7Wg","GZONNAPu0pU","H8p48OSto3s","dbB7MOoEfYk","l6BCJvoOwuw","5icpS4Ei1-w","nppW_kr3nCE","YK8zghCuXrM",
  "Mzve0X2tFFc","884c1K7ywys","EUTFMUITHN4","9eTcfOZdZEQ","5w4-HwXZ6WI","hRFUAhbNqkA","0tYtOGaWu0k","sWTIM3gGfD4","uh49gJYOVEI","RH8vNRaQkXc",
  "3ufuN1F33_0","RryyllJFGoU","iW-b4TCdWQM","Xp9K1f-Inq0","Hf-dMkfLd-Y","jQnjjUe0LKw","dmLpILQXICE","Ai-9I9QomrY","HByXUg4J6CQ","A2GGgoXI_qI",
  "P-xW23t_9zk","DFzV1L0-viw","3jDd0XYdEhc","cI-kz67r_so","WDu63fPvkNw","MGHtiaVm7K4","66D6rdoBqKk","cveAesw7qJ8","NC4uIZWsA-M","65Qxms0Tt84",
  "ZcSPq-nZQ_E","ezZi917lK0k","uRj5ZxwDZ74","r8XZgUynHF8","LwODMPOXKnM","YmsZYRGif-k","NAFAI461P8k","8UaQgSVfE9U","Vontv6CU_4k","yFqhyALA5AM",
  "mw00lx5l_lM","zC5Z__rq5Po","Zzv9Buww7N0","YPc3L-lsD34","R_43E7SnNDg","lJiGedNkpBw","35k1s58HfLA","5zwHMG9yFas","wJe-z_wKHss","PBTOELyUchE",
  "xYqskdJ-KuY"
];

const CORRECT_ANSWERS = {
   0: "14",  1: "11",  2: "14",  3: "23",  4: "27",  5: "26",  6: "17",  7: "19",  8: "18",  9: "46", 
  10: "43", 11: "42", 12: "11", 13: "14", 14: "11", 15: "48", 16: "43", 17: "42", 18: "26", 19: "27",
  20: "24", 21: "42", 22: "48", 23: "41", 24: "9",  25: "9",  26: "6",  27: "41", 28: "44", 29: "44",
  30: "21", 31: "47", 32: "41", 33: "11", 34: "47", 35: "43", 36: "29", 37: "28", 38: "28", 39: "13",
  40: "22", 41: "21", 42: "13", 43: "17", 44: "16", 45: "47", 46: "46", 47: "19", 48: "34", 49: "29",
  50: "22", 51: "27", 52: "24", 53: "11", 54: "29", 55: "18", 56: "19", 57: "42", 58: "41", 59: "31",
  60: "13", 61: "25", 62: "34", 63: "35", 64: "46", 65: "38", 66: "19", 67: "39", 68: "25", 69: "15",
  70: "14", 71: "28", 72: "39", 73: "49", 74: "29", 75: "25", 76: "42", 77: "16", 78: "48", 79: "42",
  80: "41", 81: "18", 82: "48", 83: "28", 84: "15", 85: "44", 86: "19", 87: "28", 88: "44", 89: "28",
  90: "59", 91: "54", 92: "57", 93: "79", 94: "71", 95: "72", 96: "79", 97: "71", 98: "72", 99: "89",
  100: "85", 101: "89", 102: "62", 103: "77", 104: "99", 105: "65", 106: "71", 107: "88", 108: "59", 109: "56",
  110: "58", 111: "63", 112: "54", 113: "77", 114: "67", 115: "64", 116: "63", 117: "72", 118: "78", 119: "59",
  120: "00"
};

const calculateScoreBasedOnTime = (timeRemainingSeconds, duration) => {
 /* const tier1 = duration * 0.6;
  const tier2 = duration * 0.3;

  if (timeRemainingSeconds > tier1) {
    return 3;
  } else if (timeRemainingSeconds > tier2) {
    return 2;
  } else if (timeRemainingSeconds > 0) {
    return 1;
  } else {
    return 0;
  } */
  const tier = timeRemainingSeconds / duration;
    return Math.round(tier*10);

};

function VideoDisp({ userData, onUserUpdate }) {
  const navigate = useNavigate();
  const location = useLocation();
  const playerRef = useRef(null);
  const videoTimerRef = useRef(null);
  const timerIntervalRef = useRef(null);
  const videoEndedRef = useRef(false);

  const level = location.state?.level ?? userData?.level ?? 0;
  const videoId = VIDEO_LIST[level] || VIDEO_LIST[0];
  
  const correctAudioRef = useRef(new Audio(correctSound));
  const wrongAudioRef = useRef(new Audio(wrongSound));
  const countdownAudioRef = useRef(null);

  const playCountdownSound = useCallback(() => {
    if (level <= 40) {
      countdownAudioRef.current = new Audio(countdownSound1);
    } else if (level <= 80) {
      countdownAudioRef.current = new Audio(countdownSound2);
    } else {
      countdownAudioRef.current = new Audio(countdownSound3);
    }
    
    if (countdownAudioRef.current) {
      countdownAudioRef.current.loop = true;
      countdownAudioRef.current.play().catch(e => console.error("Failed to play countdown sound:", e));
    }
  }, [level]);

  const stopCountdownSound = useCallback(() => {
    if (countdownAudioRef.current) {
      countdownAudioRef.current.pause();
      countdownAudioRef.current.currentTime = 0;
    }
  }, []);

  const updateUserLevelAndScore = useCallback(async (scoreToAdd) => {
    if (!userData?.username) {
      return;
    }

    try {
      const userRef = doc(db, "assumption", userData.username);
      const docSnap = await getDoc(userRef);

      let currentDbLevel = userData.level || 0;
      let currentDbScore = userData.score || 0;
      let currentBonus = userData.bonus || false;

      if (docSnap.exists()) {
        const dbData = docSnap.data();
        currentDbLevel = dbData.level || 0;
        currentDbScore = dbData.score || 0;
        currentBonus = dbData.bonus || false;
      }

      let newLevel = currentDbLevel;
      const newScore = currentDbScore + scoreToAdd;
      let newBonus = currentBonus;

      if (scoreToAdd > 0 && currentDbLevel < VIDEO_LIST.length - 1) {
        newLevel = currentDbLevel + 1;
        
        const bonusLevels = [20, 40, 60, 80, 100, 115];
        if (bonusLevels.includes(newLevel)) {
          newBonus = true;
        }
      }

      await setDoc(userRef, { 
        level: newLevel, 
        score: newScore,
        bonus: newBonus
      }, { merge: true });
      
      onUserUpdate(userData.username);
    } catch (error) {
      console.error("Error updating user data in Firestore:", error);
      Swal.fire('เกิดข้อผิดพลาด', 'ไม่สามารถอัปเดตข้อมูลผู้ใช้ได้', 'error');
    }
  }, [userData, onUserUpdate]);

  const checkAnswer = useCallback(async (userAnswer, timeTaken, duration) => {
    stopCountdownSound();

    const correct = CORRECT_ANSWERS[level] === userAnswer;
    let scoreEarned = 0; 
    let message = '';
    let icon = 'error';

    if (correct) {
      const timeRemainingSecondsAtSubmit = (duration * 1000 - timeTaken) / 1000;
      scoreEarned = calculateScoreBasedOnTime(timeRemainingSecondsAtSubmit, duration); 
      
 /*     if (scoreEarned === 3) {
        message = 'ยอดเยี่ยม! คุณตอบถูกและเร็วมาก';
      } else if (scoreEarned === 2) {
        message = 'ดีมาก! คุณตอบถูก';
      } else if (scoreEarned === 1) {
        message = 'ถูกต้อง! แต่ยังช้าไปหน่อย';
      } else {
          message = 'ถูกต้อง! แต่หมดเวลาพอดี จึงไม่ได้คะแนน';
          scoreEarned = 0;
      } */
      message = `ตอบถูก! คุณได้ ${scoreEarned} คะแนน`;



      correctAudioRef.current.play();
      icon = 'success';
    } else {
      scoreEarned = 0;
      message = `ตอบผิด! ลองใหม่อีกครั้ง`;
      wrongAudioRef.current.play();
      icon = 'error';
    }

    await Swal.fire({
      icon: icon,
      title: correct ? 'ถูกต้อง!' : 'ลองใหม่!',
      text: message,
      confirmButtonText: 'ตกลง'
    });

    await updateUserLevelAndScore(scoreEarned);
    navigate('/exercies');
  }, [level, navigate, stopCountdownSound, updateUserLevelAndScore]);

  const showAnswerForm = useCallback(() => {
    stopCountdownSound();

    if (videoTimerRef.current) {
      clearTimeout(videoTimerRef.current);
    }

    if (timerIntervalRef.current) {
      clearInterval(timerIntervalRef.current);
    }

    if (playerRef.current && typeof playerRef.current.pauseVideo === 'function') {
      playerRef.current.pauseVideo();
    }

    let timerDuration;
    if (level <= 40) {
      timerDuration = 10;
    } else if (level <= 80) {
      timerDuration = 8;
    } else {
      timerDuration = 7;
    }

    let timer = timerDuration;
    let currentPossibleScore = calculateScoreBasedOnTime(timer, timerDuration);

    playCountdownSound();

    Swal.fire({
      title: 'ตอบคำถาม',
      html: `
        เหลือเวลา: <strong id="swal-countdown-timer" class="swal-big-text">${timer}</strong> วินาที<br>
        คะแนนที่จะได้: <span id="swal-possible-score" class="swal-big-text">${currentPossibleScore}</span> คะแนน<br>
        <input id="swal-input" class="swal2-input" placeholder="คำตอบของคุณ..." 
               type="number" inputmode="numeric" pattern="[0-9]*">
      `,
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: false,
      confirmButtonText: 'ส่งคำตอบ',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      timer: timerDuration * 1000, // ตั้งค่า timer ให้ปิดอัตโนมัติ
      timerProgressBar: true, // แสดง progress bar
      
      didOpen: () => {
        const input = Swal.getPopup().querySelector('#swal-input');
        input.focus();
        const timerTextElement = Swal.getPopup().querySelector('#swal-countdown-timer');
        const possibleScoreElement = Swal.getPopup().querySelector('#swal-possible-score');
        
        input.addEventListener('keypress', (e) => {
          if (e.key === 'Enter') {
            Swal.clickConfirm();
          }
        });

        timerIntervalRef.current = setInterval(() => {
          timer--;
          if (timerTextElement) { 
              timerTextElement.textContent = timer;
          }
          
          currentPossibleScore = calculateScoreBasedOnTime(timer, timerDuration);
          if (possibleScoreElement) {
              possibleScoreElement.textContent = currentPossibleScore;
          }

          // เมื่อหมดเวลา ปิดกล่องและนำทางไปหน้า exercies
          if (timer <= 0) {
            clearInterval(timerIntervalRef.current);
            stopCountdownSound();
            
            // ปิดกล่อง SweetAlert2 และนำทางไปหน้า exercies
            Swal.close();
            navigate('/exercies');
          }
        }, 1000);
      },
      preConfirm: () => {
        const answer = Swal.getPopup().querySelector('#swal-input').value;
        const timeRemaining = timer * 1000;
        const timeTaken = (timerDuration * 1000) - timeRemaining;
        return { 
          answer: answer, 
          timeTaken: timeTaken,
          duration: timerDuration
        };
      },
      willClose: () => {
        if (timerIntervalRef.current) {
          clearInterval(timerIntervalRef.current);
          timerIntervalRef.current = null;
        }
        stopCountdownSound();
      }
    }).then((result) => {
      // ตรวจสอบว่าปิดเพราะหมดเวลาหรือไม่
      if (result.dismiss === Swal.DismissReason.timer) {
        console.log("Closed because of timer");
        navigate('/exercies');
      }
      // ตรวจสอบว่าผู้ใช้ส่งคำตอบ
      else if (result.isConfirmed) {
        checkAnswer(result.value.answer, result.value.timeTaken, result.value.duration);
      }
    });
  }, [checkAnswer, navigate, playCountdownSound, stopCountdownSound, playerRef, level]);

  const onPlayerReady = useCallback((event) => {
    playerRef.current = event.target;
    if (playerRef.current) {
      playerRef.current.playVideo();
    }

    videoTimerRef.current = setTimeout(() => {
      if (videoEndedRef.current) {
        return;
      }
      Swal.fire({
        icon: 'info',
        title: 'เวลาหมด',
        text: 'คุณต้องตอบคำถามเมื่อวิดีโอจบ',
        confirmButtonText: 'ตกลง',
      }).then(() => {
        navigate('/exercies');
      });
    }, 30000);
  }, [navigate, videoEndedRef]);

  const onPlayerStateChange = useCallback((event) => {
    if (event.data === 0) { 
      videoEndedRef.current = true;

      if (videoTimerRef.current) {
        clearTimeout(videoTimerRef.current);
        videoTimerRef.current = null;
      }
      
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = null;
      }
      
      stopCountdownSound();
      showAnswerForm();
    }
  }, [showAnswerForm, stopCountdownSound]);

  useEffect(() => {
    return () => {
      if (timerIntervalRef.current) {
        clearInterval(timerIntervalRef.current);
      }
      if (videoTimerRef.current) {
        clearTimeout(videoTimerRef.current);
      }
      stopCountdownSound();

      if (correctAudioRef.current) {
        correctAudioRef.current.pause();
        correctAudioRef.current.currentTime = 0;
      }
      if (wrongAudioRef.current) {
        wrongAudioRef.current.pause();
        wrongAudioRef.current.currentTime = 0;
      }
      
      // Destroy YouTube player
      if (playerRef.current) {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [stopCountdownSound]);

  const opts = {
    height: '100%',
    width: '100%',
    playerVars: {
      autoplay: 1,
      controls: 0,
      rel: 0,
      modestbranding: 1,
      fs: 1,
    },
  };

  return (
    <div className="video-page-container">
      <div className="video-section">
        <div className="youtube-container">
          <YouTube
            key={videoId}
            videoId={videoId}
            opts={opts}
            onReady={onPlayerReady}
            onStateChange={onPlayerStateChange}
            onError={(e) => console.error("YouTube Player Error:", e)}
          />
        </div>
      </div>
    </div>
  );
}

export default VideoDisp;